import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const P = styled.p`
  font-family: 'Nunito', sans-serif;
  font-size: 18px;
  color: ${props => props.light ? 'white' : '#505663'};
  line-height: 32px;
  white-space: pre-wrap;
  text-align: center;
  width: 90%;
  padding: 0 5%;
  a {
    color: #FF6F43;
  }
  @media (min-width: ${breakpoints.desktop}) {
    font-size: 22px;
    text-align: left;
    width: auto;
    padding: inherit;
  }
`;

export default P;



// WEBPACK FOOTER //
// ./src/styled-components/P.js